/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../bbfrontend/common/glyph/glyph_icon';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbcategoriescommon": {
        "nested": {
          "frontend": {
            "nested": {
              "ActivityItemDetailLineItem": {
                "fields": {},
                "nested": {
                  "CategoryData": {
                    "fields": {
                      "translatedLabel": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "translatedCategoryName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "categoryId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "categoryPillStyle": {
                        "type": ".squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem.CategoryData.PillStyle",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PillStyle": {
                        "fields": {
                          "icon": {
                            "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lightModeColors": {
                            "type": ".squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem.CategoryData.PillStyle.Colors",
                            "id": 2,
                            "rule": "optional"
                          },
                          "darkModeColors": {
                            "type": ".squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem.CategoryData.PillStyle.Colors",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Colors": {
                            "fields": {
                              "backgroundColorCode": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "iconColorCode": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "textColorCode": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbcategoriescommon?.nested?.frontend?.nested?.ActivityItemDetailLineItem && !$root.nested?.squareup?.nested?.bbcategoriescommon?.nested?.frontend?.nested?.ActivityItemDetailLineItem?.nested?.CategoryData && !$root.nested?.squareup?.nested?.bbcategoriescommon?.nested?.frontend?.nested?.ActivityItemDetailLineItem?.nested?.CategoryData?.nested?.PillStyle && !$root.nested?.squareup?.nested?.bbcategoriescommon?.nested?.frontend?.nested?.ActivityItemDetailLineItem?.nested?.CategoryData?.nested?.PillStyle?.nested?.Colors) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ActivityItemDetailLineItem @ squareup/bbcategoriescommon/frontend/frontend.proto at 10:1
 */
export const ActivityItemDetailLineItem = $root.lookupType('squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem');
fixType(ActivityItemDetailLineItem);
Builder.createAndAttachToType(ActivityItemDetailLineItem);
/**
 * SOURCE CategoryData @ squareup/bbcategoriescommon/frontend/frontend.proto at 11:3
 */
ActivityItemDetailLineItem.CategoryData = $root.lookupType('squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem.CategoryData');
fixType(ActivityItemDetailLineItem.CategoryData, {
  translatedLabel: {
    notEmpty: true
  },
  translatedCategoryName: {
    notEmpty: true
  },
  categoryId: {
    notEmpty: true
  },
  categoryPillStyle: {
    required: true
  }
});
Builder.createAndAttachToType(ActivityItemDetailLineItem.CategoryData);
/**
 * SOURCE PillStyle @ squareup/bbcategoriescommon/frontend/frontend.proto at 24:5
 */
ActivityItemDetailLineItem.CategoryData.PillStyle = $root.lookupType('squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem.CategoryData.PillStyle');
fixType(ActivityItemDetailLineItem.CategoryData.PillStyle, {
  lightModeColors: {
    required: true
  },
  darkModeColors: {
    required: true
  }
});
Builder.createAndAttachToType(ActivityItemDetailLineItem.CategoryData.PillStyle);
/**
 * SOURCE Colors @ squareup/bbcategoriescommon/frontend/frontend.proto at 29:7
 */
ActivityItemDetailLineItem.CategoryData.PillStyle.Colors = $root.lookupType('squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem.CategoryData.PillStyle.Colors');
fixType(ActivityItemDetailLineItem.CategoryData.PillStyle.Colors, {
  backgroundColorCode: {
    notEmpty: true
  },
  iconColorCode: {
    notEmpty: true
  },
  textColorCode: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActivityItemDetailLineItem.CategoryData.PillStyle.Colors);